import { ConditionOperatorEnum, ECVAnalyzeAutomationRuleWhenSourceType, EUserConsentType } from "./enums";

export const credentialKey = 'vinter.credentials';
export const cryptedCredentialKey = 'vinter.cryptedCredentials';
export const sideNavMenuKey = "vinter.sideNavMenu";
export const cachePersistenceKey = 'vinter.httpCache';
export const languageKey = 'vinter.selectedLanguage';
export const mailKey = 'vinter.mail';
export const rememberKey = 'vinter.remember';
export const pinnedTabIndex = 'vinter.pinnedTabIndex';
export const defaultGuid: string = "00000000-0000-0000-0000-000000000000";
export const mainOrganizationGuid: string = "ea1bf6a1-af29-46d2-aff7-f120bdb4f553";
export const vinterOrganizationGuid: string = "ea1bf6a1-af29-46d2-aff7-f120bdb4f553";
export const vinterLogoPath: string = "assets/vinter/images/NORM_HOLDING_VINTER_LOGO-01.png";
// export const vinterLogoWithoutTextPath: string = "assets/vinter/images/vinter_logo_withoutText.png";
export const vinterPureLogoPath: string = "assets/vinter/images/NORM_HOLDING_VINTER_LOGO-02.png";
export const vinterPureLogoRotatedPath: string = "assets/vinter/images/rotated_logo_vinter.png";
export const flagTRPath: string = "assets/vinter/images/tr.png";
export const flagTRSvgPath: string = "assets/vinter/images/tr_flag.svg";
export const flagENPath: string = "assets/vinter/images/en.jpg";
export const trShortText: string = "tr-TR";
export const enShortText: string = "en-US";

export const invitationTemplateFilePath: string = "assets/vinter/files/VinterMailListTemplate.xls";
export const VINTERADMIN: string = "VINTERADMIN";
export const ORGADMIN: string = "ORGADMIN";
export const HR: string = "HR";
export const APPLICANT: string = "APPLICANT";
export const passwordMinCharcount: number = 8;
export const paginatorRowCount: number = 8;
export const maxImageSize: number = 20000000;

export const ExistingEmail: string = "ExistingEmail";
export const ExistingManager: string = "ExistingManager";
export const LicenseUsageError: string = "LicenseUsageError";
export const UserFilledFormAlready: string = "UserFilledFormAlready";

export const AttributeList: { name: string; code: string }[] = [
    { name: 'PositionTitle', code: '{positionTitle}' },
    { name: 'StepName', code: '{stepName}' },
    { name: 'ApplicantName', code: '{applicantName}' },
    { name: 'OrganizationTitle', code: '{organizationTitle}' }
];

export const UserConsentTypeStrings = {
    [EUserConsentType.TermsOfUse]: "Key.TermsOfUse",
    [EUserConsentType.PrivacyPolicy]: "Key.PrivacyPolicy",
    [EUserConsentType.CookiePolicy]: "Key.CookiePolicy",
    [EUserConsentType.HrDisclosure]: "Key.HrDisclosure",
    [EUserConsentType.TEIOM]: "Key.TEIOM",
    [EUserConsentType.ApplicantDisclosure]: "Key.ApplicantDisclosure"
};



export const CVAnalyzeRuleConditionList = {
    [ECVAnalyzeAutomationRuleWhenSourceType.Degree]: { name: 'Degree', operatorList: [ConditionOperatorEnum.Equals, ConditionOperatorEnum.LessThan, ConditionOperatorEnum.GreaterThan] },
    [ECVAnalyzeAutomationRuleWhenSourceType.WorkExperience]: { name: 'WorkExperience', operatorList: [ConditionOperatorEnum.Equals, ConditionOperatorEnum.LessThan, ConditionOperatorEnum.GreaterThan] },
    [ECVAnalyzeAutomationRuleWhenSourceType.GPAMean]: { name: 'GPAMean', operatorList: [ConditionOperatorEnum.Equals, ConditionOperatorEnum.LessThan, ConditionOperatorEnum.GreaterThan] },
    [ECVAnalyzeAutomationRuleWhenSourceType.Language]: { name: 'Language', operatorList: [ConditionOperatorEnum.Equals, ConditionOperatorEnum.LessThan, ConditionOperatorEnum.GreaterThan] },
    // Faz 3 — CV Score kuralı: sadece GreaterThan operator (eşik değerinin üstündeyse tetiklenir).
    [ECVAnalyzeAutomationRuleWhenSourceType.Score]: { name: 'Score', operatorList: [ConditionOperatorEnum.GreaterThan] },
}
export const ThreeHoursInMS = 3 * 60 * 60 * 1000;
export const HowToCalculateScoreAndRating = "HowToCalculateScoreAndRating";
export const ExplanationOfCalculatingScoreAndRating = "ExplanationOfCalculatingScoreAndRating";
export const QuesitonWeightIcon = "assets/vinter/icons/weight-icon.svg";
export const QuestionWeightToolTipIcon = "assets/vinter/icons/tooltip-info-icon.svg";
export const SpeakingIcon = "assets/vinter/icons/speaking-icon-circled.svg";
export const WritingIconPath = "assets/vinter/icons/writing-icon-circled.svg";
export const ListeningIconPath = "assets/vinter/icons/listening-icon-circled.svg";
export const ReadingIconPath = "assets/vinter/icons/reading-icon-circled.svg";
export const VocabularyIconPath = "assets/vinter/icons/vocabulary-icon-circled.svg";
export const GrammerIconPath = "assets/vinter/icons/grammer-icon-circled.svg";
export const AICommentsIconPath = "assets/vinter/icons/text-grammar-error-regular.svg"
export const unifiedWorkspaceID: string = "66e93d1eb2e44db1f5edbd09";
export const RefreshIcon = "assets/vinter/icons/green-refresh-icon.svg"
export const HyundaiGUID = "809e3ecc-13cd-4c60-a194-17ec05b59653";
export const LevelEnglishID = "200fe3a7-89d6-45e5-b22d-3bbd3f75995b";
export const FetchApplicantsIcon = "assets/vinter/icons/fetch-applicants.svg";
export const positionStepEmptyIcon: string = "assets/vinter/icons/positionStepEmpty.svg";
export const positionStepListIcon: string = "assets/vinter/icons/pozisyon-detay-icon-park-outline-list-success.svg";
export const positionStepTextIcon: string = "assets/vinter/icons/pozisyon-detay-icon-park-text-style-one.svg";
export const positionStepVideoIcon: string = "assets/vinter/icons/pozisyon-detay-tabler-video.svg";
export const positionStepCodingQuestionIcon: string = "assets/vinter/icons/pozisyon-detay-tabler-coding-question.svg";
export const flagENSvgPath: string = "assets/vinter/images/en_flag.svg";
export const vinterLogoWithoutTextPath: string = "assets/vinter/images/vinter_logo.svg";
export const timeIconOutline: string = "assets/vinter/icons/time-icon-outline.svg";
export const eyeIconOutline: string = "assets/vinter/icons/eye-icon.svg";
export const VinterAICommentIcon = "assets/vinter/icons/ai-comment-icon.svg";

export const TechnicalIconPath = "assets/vinter/icons/question-collection-category-icons/technical.svg";
export const CompetenceIconPath = "assets/vinter/icons/question-collection-category-icons/competence.svg";
export const CognitiveAbilityIconPath = "assets/vinter/icons/question-collection-category-icons/cognitive-ability.svg";
export const ForeignLanguageIconPath = "assets/vinter/icons/question-collection-category-icons/foreign-language.svg";
export const PersonalityIconPath = "assets/vinter/icons/question-collection-category-icons/personality.svg";
export const PronunciationIconPath = "assets/vinter/icons/question-collection-category-icons/pronunciation.svg";
export const CustomIconPath = "assets/vinter/icons/question-collection-category-icons/custom.svg";
export const CaseStudyIconPath = "assets/vinter/icons/question-collection-category-icons/case-study.svg";
export const SpecialSelectIconPath = "assets/vinter/icons/question-collection-category-icons/speacial-select.svg";
export const VideoMeetingIconPath = "assets/vinter/icons/question-collection-category-icons/video-meeting-icon.svg";
export const VIDEO_MEETING_CATEGORY_ID = 'VideoMeeting';

// Faz 3 — CV Scoring frontend-only kategori sabiti. QuestionCollection tablosuna karşılık gelmez;
// backend PositionStep(Type=CV=4) + CriteriaSet + otomatik Score kuralını cvStep DTO'sundan yaratır.
export const CV_SCORING_CATEGORY_ID = 'CvScoring';
// Icon: CV Scoring modülünün kendi ikonu.
export const CvScoringStepIconPath = "assets/vinter/icons/cv-scroing-icon.svg";

export const LevelEnglishEN = "Level English";
export const LevelEnglishDescriptionEN = "The test, which was created to measure the level, was meticulously designed with inspiration from Weir's socio-cognitive model, the communicative approach and the CEFR's level descriptors. The test assesses language candidates' basic grammar, vocabulary, reading and listening skills. The test consists of four main sections: Grammar and Vocabulary, Reading, Listening and Writing. Each section aims to accurately reflect the language competencies needed to be successful in everyday communication and to understand key terms used in the workplace.";
export const LevelEnglishTR = "Seviyeli İngilizce";
export const LevelEnglishDescriptionTR = "Adayın seviyesini ölçmek amacıyla oluşturulan test, Weir'in sosyo-bilişsel modelinden, iletişimsel yaklaşımdan ve CEFR'in seviye tanımlayıcılarından ilham alarak titizlikle tasarlanmıştır. Bu test, dil adayların temel dilbilgisi, kelime bilgisi, okuma ve dinleme becerilerini değerlendirmektedir. Test, dört ana bölümden oluşur: Dilbilgisi ve Kelime Bilgisi, Okuma, Dinleme ve Yazma. Her bölüm, günlük iletişimde başarılı olabilmek ve iş yerinde kullanılan temel terimleri anlayabilmek için gereken dil yeterliliklerini doğru bir şekilde yansıtmayı amaçlamaktadır.";

export const LevelGermanEN = "Level German";
export const LevelGermanDescriptionEN = "The test has been carefully designed with the support of expert academics, inspired by the CEFR level descriptors.. This test evaluates candidates’ fundamental language skills, including grammar, vocabulary, reading, and listening. It consists of four main sections: Grammar, Vocabulary, Reading, and Listening. Each section aims to accurately reflect the language competencies required for successful everyday communication and understanding of basic workplace terminology.";
export const LevelGermanTR = "Seviyeli Almanca";
export const LevelGermanDescriptionTR = "Adayın seviyesini ölçmek amacıyla oluşturulan test, alanında uzman akademisyenlerin desteği ile CEFR'in B2 seviye tanımlayıcılarından ilham alarak titizlikle tasarlanmıştır. Bu test, dil adayların temel dilbilgisi, kelime bilgisi, okuma ve dinleme becerilerini değerlendirmektedir. Test, dört ana bölümden oluşur: Dilbilgisi, Kelime Bilgisi, Okuma ve Dinleme. Her bölüm, günlük iletişimde başarılı olabilmek ve iş yerinde kullanılan temel terimleri anlayabilmek için gereken dil yeterliliklerini doğru bir şekilde yansıtmayı amaçlamaktadır.";


export const VinterSimpleLicenseParameterKey = "vintersimple";

export const ShuffleCognitiveQuestionCollectionID = "be3d573e-4d36-4f2d-a421-1351f6f2cc87";

export const LanguageDisplayNameToKeyMapping: { [key: string]: string } = {
    'Türkçe(TR)': 'Turkish(TR)',
    'Turkish(TR)': 'Turkish(TR)',
    'İngilizce(EN)': 'English(EN)', 
    'English(EN)': 'English(EN)',
}

export const LanguageShortKeyPrefix = 'QCollectionShort';

export const InternationalDrivingLicenseCategories = [
  { name: 'M',   code: '1'  },
  { name: 'A1',  code: '2'  },
  { name: 'A2',  code: '3'  },
  { name: 'A',   code: '4'  },
  { name: 'B1',  code: '5'  },
  { name: 'B',   code: '6'  },
  { name: 'BE',  code: '7'  },
  { name: 'C1',  code: '8'  },
  { name: 'C1E', code: '9'  },
  { name: 'C',   code: '10' },
  { name: 'CE',  code: '11' },
  { name: 'D1',  code: '12' },
  { name: 'D1E', code: '13' },
  { name: 'D',   code: '14' },
  { name: 'DE',  code: '15' },
  { name: 'F',   code: '16' },
  { name: 'G',   code: '17' }
];